import React from 'react';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ToggleButton } from 'primereact/togglebutton';
import { validacaoFormImagens } from '../helpers/validacao';

export default function     FormCadastrarLinks({ edit = false,handleSubmitFormik,initialValues= { nome: '',
    url: '' } }) {
    return (
        <>
            
            <Formik
                initialValues={initialValues}
                validationSchema={validacaoFormImagens}
                onSubmit={handleSubmitFormik}
            >{({ values }) => (
                    <Form className="form-wrapper">
                        <div className="content-wrapper">
                            <div className="form-item">
                                <div className="form-item-label">
                                    <label htmlFor="nome">Nome do Link</label>
                                </div>
                                <Field
                                    as={InputText}
                                    id="nome"
                                    name="nome"
                                    type="text"
                                    size={30}
                                    maxLength={60}
                                />

                                <ErrorMessage
                                    className="error-message"
                                    name="nome"
                                    component="div"
                                />
                            </div>

                            <div className="form-item">
                                <div className="form-item-label">
                                    <label htmlFor="url">Link</label>
                                </div>
                                <Field
                                    as={InputText}
                                    id="url"
                                    name="url"
                                    type="url"
                                    size={30}
                                    maxLength={999}
                                />

                                <ErrorMessage
                                    className="error-message"
                                    name="url"
                                    component="div"
                                />
                            </div>
                            {edit && <div className="form-item">
                                <div className="form-item-label">
                                    <label htmlFor="status">Status</label>
                                </div>
                                <Field
                                    as={ToggleButton}
                                    id="status"
                                    name="status"
                                    type="status"
                                    checked = {values.status}
                                    onLabel="Ativo"
                                    offLabel="Inativo"
                                    size={30}
                                    maxLength={999}
                                />

                                <ErrorMessage
                                    className="error-message"
                                    name="status"
                                    component="div"
                                />
                            </div>}
                        </div>
                        <div className="edit-button">
                            <Button
                                type="submit"
                                className={edit && 'p-button-warning'}
                                label="Enviar"
                                icon="pi pi-caret-right"
                                iconPos="right"
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
}
